import React, { Component, type ErrorInfo, type ReactNode } from 'react';
import { translate as t } from 'utils/i18nTranslate';
import {
  isChunkLoadError,
  tryReloadOnceForChunkLoadError,
} from 'utils/chunkLoadError';
import styles from './RouteChunkErrorBoundary.module.scss';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  isChunkError: boolean;
}

class RouteChunkErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, isChunkError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      isChunkError: isChunkLoadError(error),
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('RouteChunkErrorBoundary caught an error:', error, errorInfo);

    if (isChunkLoadError(error)) {
      tryReloadOnceForChunkLoadError(error);
    }
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    if (this.state.isChunkError) {
      return (
        <div className={styles.container}>
          <p className={styles.title}>
            {t('components.routeChunkErrorBoundary.chunkTitle')}
          </p>
          <p className={styles.message}>
            {t('components.routeChunkErrorBoundary.chunkMessage')}
          </p>
          <button
            type="button"
            className={styles.button}
            onClick={() => window.location.reload()}
          >
            {t('components.routeChunkErrorBoundary.reloadButton')}
          </button>
        </div>
      );
    }

    return (
      <div className={styles.container}>
        <p className={styles.title}>
          {t('components.routeChunkErrorBoundary.errorTitle')}
        </p>
        <p className={styles.message}>
          {t('components.routeChunkErrorBoundary.errorMessage')}
        </p>
        <button
          type="button"
          className={styles.button}
          onClick={() => window.location.reload()}
        >
          {t('components.routeChunkErrorBoundary.reloadButton')}
        </button>
      </div>
    );
  }
}

export default RouteChunkErrorBoundary;
